import { cn } from "@/lib/utils/cn";
import { type ComponentPropsWithoutRef } from "react";

type TaskStatus = "open" | "in-progress" | "completed";

const STATUS_COLORS: Record<TaskStatus, { stroke: string; fill: string }> = {
  open: { stroke: "#9ca3af", fill: "transparent" },
  "in-progress": { stroke: "#facc15", fill: "#facc15" },
  completed: { stroke: "#10b981", fill: "#10b981" },
};

export type TaskStatusIconProps = {
  status?: TaskStatus;
} & ComponentPropsWithoutRef<"svg">;

export const TaskStatusIcon = ({
  status,
  className,
  ...props
}: TaskStatusIconProps) => {
  const { stroke, fill } = STATUS_COLORS[status ?? "open"];
  const innerRadius = 4;

  return (
    <svg
      viewBox="0 0 16 16"
      role="img"
      aria-hidden="true"
      className={cn("h-4 min-w-4", className)}
      {...props}
    >
      {status === "completed" ? (
        <>
          <circle cx="8" cy="8" r="7" fill={fill} />
          <path
            d="M5.8 8.2l1.9 1.9L10.2 7"
            fill="none"
            stroke="#ffffff"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ) : (
        <>
          <circle
            cx="8"
            cy="8"
            r="7"
            strokeWidth="2"
            fill="none"
            stroke={stroke}
          />
          {status === "open" && (
            <path
              fill={stroke}
              fillOpacity={0.35}
              d="
              M8 2
              A6 6 0 0 1 12.242 6
              L8 8Z"
            />
          )}
          {status === "in-progress" && (
            <path
              fill={fill}
              d={`M8 ${8 - innerRadius}A${innerRadius} ${innerRadius} 0 0 1 ${
                8 + innerRadius
              } 8A${innerRadius} ${innerRadius} 0 0 1 8 ${
                8 + innerRadius
              }L8 8Z`}
            />
          )}
        </>
      )}
    </svg>
  );
};
